import axios, { AxiosResponse } from 'axios';
import errorHandler from './error';
import { IFilters, IFilter } from '@/modules/calendar/interfaces/IFilter';
import { getFiltersUrl } from '@/utils/filters';
import { buildCollectionFilter } from '@/utils/filters';

const API = {
    prod1: 'https://api.schedule.esens.com.pl/odata/schedules/',
    // dev: 'https://devapi.schedule.esens.com.pl/odata/schedules/',
    // dev: 'http://devapi.zoukwroclove.pl/odata/schedules/',
    dev: 'http://localhost:54328',
};

function getBaseUrl(host: string | null = null) {
    return (host ?? API.dev) + '/odata/schedules/';
}

function createWithoutExpiredFilter(): string {
    const currentTimestamp = new Date().toISOString();
    return `(EndDate gt ${currentTimestamp})`;
}

function isNavigationProperty(filter: IFilter): boolean {
    return filter.details.navigationProperty ? true : false;
}

export function buildQuery(filters: IFilters, apiUrl: string | null = null, eventId: number | null = null): string {
    const allFilters: IFilter[][] = Object.values(filters);
    const navigationPropertiesFilters: IFilter[][] = allFilters.filter((f: IFilter[]) => isNavigationProperty(f[0]));
    const mainPropertiesFilters: IFilter[][] = allFilters.filter((f: IFilter[]) => !isNavigationProperty(f[0]));
    const navigationPropertiesFiltersStrings = buildCollectionFilter(navigationPropertiesFilters);
    const mainPropertiesFiltersUrl = getFiltersUrl(mainPropertiesFilters);

    const expandedFilter =
        navigationPropertiesFilters.length === 0
            ? 'DanceStyleCategories'
            : // eslint-disable-next-line @typescript-eslint/no-explicit-any
              navigationPropertiesFilters.map((filter: any) => `${filter[0].odataName}`).join(',');
    const mainFilter = createWithoutExpiredFilter() + mainPropertiesFiltersUrl;

    const baseUrl = getBaseUrl(apiUrl);

    // const queryString =
    //     navigationPropertiesFiltersStrings !== ''
    //         ? `${baseUrl}PeriodicalGroups?$expand=${expandedFilter}&$filter=${mainFilter} and ${navigationPropertiesFiltersStrings}`
    //         : `${baseUrl}PeriodicalGroups?$expand=${expandedFilter}&$filter=${mainFilter}`;

    const eventFilter = eventId ? `Id gt ${9999} and ` : `Id gt ${9999} and `;
    const queryString =
        navigationPropertiesFiltersStrings !== ''
            ? `${baseUrl}PeriodicalGroups?$filter=${eventFilter}${mainFilter} and ${navigationPropertiesFiltersStrings}`
            : `${baseUrl}PeriodicalGroups?$filter=${eventFilter}${mainFilter}`;

    return queryString;
}

export function createAllPeriodicalGroupUrl(apiUrl: string | null = null): string {
    // const periodical = 'PeriodicalGroups?$orderby=WeekDayId%20asc,StartTime%20asc&$expand=DanceStyleCategories';
    const periodical = 'PeriodicalGroups?$orderby=WeekDayId%20asc,StartTime%20asc';
    const url = getBaseUrl(apiUrl) + periodical + '&$filter=' + createWithoutExpiredFilter();
    return url;
}

export function createFilteredPeriodicalGroupsUrl(filters?: string, apiUrl: string | null = null): string {
    const url = createAllPeriodicalGroupUrl(apiUrl);
    return typeof filters === 'string' ? url + filters : url;
}

export function createFilteredDanceStyleCategoriesUrl(filters?: string, apiUrl: string | null = null) {
    const url = `${getBaseUrl(
        apiUrl,
        // )}PeriodicalGroups?$expand=DanceStyleCategories($filter=(IsActive eq true))&$filter=${createWithoutExpiredFilter()}`;
    )}PeriodicalGroups?$filter=${createWithoutExpiredFilter()}`;
    const filtered = `${getBaseUrl(
        apiUrl,
        // )}PeriodicalGroups?$expand=DanceStyleCategories($filter=(IsActive eq true)${filters})&$filter=${createWithoutExpiredFilter()}`;
    )}PeriodicalGroups?${filters})&$filter=${createWithoutExpiredFilter()}`;
    return typeof filters === 'string' ? filtered : url;
}

export function sendRequest(url: string) {
    return axios(url)
        .then((response: AxiosResponse) => response.data.value)
        .catch(errorHandler);
}
